import { render, staticRenderFns } from "./BasalamWeight.vue?vue&type=template&id=e55722dc&scoped=true"
import script from "./BasalamWeight.vue?vue&type=script&lang=js"
export * from "./BasalamWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55722dc",
  null
  
)

export default component.exports